import { BrowserRouter, Switch, Route } from "react-router-dom";
import Signin from "./user/Signin";
import AdminRoute from "./auth/helper/AdminRoutes";
import PrivateRoute from "./auth/helper/PrivateRoutes";
import Dashboard from "./admin/Dashboard";
import FeedItems from "./admin/FeedItems";
import FeedSearch from "./admin/FeedSearch";
import Subadmins from "./admin/Subadmins";
import AddSubadmin from "./admin/AddSubadmin";
import UpdateSubadmin from "./admin/UpdateSubadmin";
import ServerHealth from "./admin/ServerHealth";
import RedisMonitor from "./admin/RedisMonitor";
import LoginLogs from "./admin/LoginLogs";
import FeedSources from "./admin/FeedSources";
import AddFeed from "./admin/AddFeed";
import FilterRules from "./admin/FilterRules";
import FeedSettings from "./admin/FeedSettings";
import Profile from "./admin/Profile";
import Companies from "./admin/Companies";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/"           component={Signin} />
      <Route path="/login"            component={Signin} />
      <AdminRoute path="/dashboard"                           component={Dashboard}    pageKey="dashboard" />
      <AdminRoute path="/subadmins"                          component={Subadmins}    pageKey="subadmins" />
      <AdminRoute path="/add/subadmin"                       component={AddSubadmin}  pageKey="subadmins" />
      <AdminRoute path="/update/subadmin/:subadminId"        component={UpdateSubadmin} pageKey="subadmins" />
      <AdminRoute path="/server"                             component={ServerHealth} pageKey="server" />
      <AdminRoute path="/redis"                              component={RedisMonitor} pageKey="redis" />
      <AdminRoute path="/login-logs"                         component={LoginLogs}    pageKey="login-logs" />
      <AdminRoute path="/sources"                            component={FeedSources}  pageKey="sources" />
      <AdminRoute path="/add/feed"                          component={AddFeed}      pageKey="sources" />
      <AdminRoute path="/edit/feed/:feedId"                 component={AddFeed}      pageKey="sources" />
      <AdminRoute path="/filter-rules"                      component={FilterRules}  pageKey="sources" />
      <AdminRoute path="/feed-settings"                     component={FeedSettings} pageKey="dashboard" />
      <AdminRoute path="/companies"                         component={Companies}    pageKey="companies" />
      <PrivateRoute path="/profile"   component={Profile} />
      <PrivateRoute path="/feeds"     component={FeedItems} />
      <PrivateRoute path="/search"    component={FeedSearch} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
